import { ConversationChannelTypeExtended } from '@provision/chat-utils';
import { ConversationParticipation } from '@provision/entity-types';
import React from 'react';
import { Partner, UserGroupRules } from 'src/graphql';
import { UserPresence } from 'src/graphql/entities/user-presence/user-presence';
import { UseSelectedParticipants } from 'src/pages/Conversations/Chat/ParticipationPanel/use-selected-participants';
import { createContext, useContextSelector } from 'use-context-selector';

export interface ChatCommonData {
  conversationId: string;
  partnerId: string;
  hasAssociatedAddresses: boolean;
  partners: Record<string, Partner>;
  userPresenceMap: Map<string, UserPresence>;
  conversationParticipations: ConversationParticipation[];
  selectedParticipantsState: UseSelectedParticipants;
  channel: ConversationChannelTypeExtended | null;
  isChatReadOnly: boolean;
  groupRules: Record<UserGroupRules, boolean>;
  chatRef: React.RefObject<HTMLDivElement | null>;
}

export const ChatCommonDataContext = createContext<ChatCommonData>(null!);

export function useChatCommonData<T>(selector: (s: ChatCommonData) => T): T {
  return useContextSelector(ChatCommonDataContext, selector);
}
